import { createSlice } from "@reduxjs/toolkit";
import {
    addProcessorMotherBoardsMaxRam,
    fetchProcessorMaxRamAttributes,
    fetchProcessorMotherBoardsMaxRamById,
    updateProcessorMotherBoardsMaxRam,
    updateStatusInProcessorMotherBoardsMaxRam,
} from "./thunk";

interface CategoryState {
    processor_motherboards_max_ram_list: any[];
    rowCount: number;
    loading: boolean;
    error: string | null;
    selectedCategories: any;
}

const initialState: CategoryState = {
    processor_motherboards_max_ram_list: [],
    rowCount: 0,
    loading: false,
    error: null,
    selectedCategories: null,
};

const categorySlice = createSlice({
    name: "processor_motherboards_max_ram",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProcessorMaxRamAttributes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProcessorMaxRamAttributes.fulfilled, (state, action) => {
                state.loading = false;
                state.processor_motherboards_max_ram_list = action.payload.data;
                state.rowCount = action.payload.rowCount;
            })
            .addCase(fetchProcessorMaxRamAttributes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch Categories";
            })
            .addCase(fetchProcessorMotherBoardsMaxRamById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProcessorMotherBoardsMaxRamById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedCategories = action.payload;
            })
            .addCase(fetchProcessorMotherBoardsMaxRamById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(addProcessorMotherBoardsMaxRam.fulfilled, (state, action) => {
                if (!action.payload?.id) return;
                state.processor_motherboards_max_ram_list = state.processor_motherboards_max_ram_list.map((processor_motherboards_max_ram) =>
                    processor_motherboards_max_ram.id === action.payload.id ? action.payload : processor_motherboards_max_ram
                );
            })
            .addCase(addProcessorMotherBoardsMaxRam.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to update Processor MotherBoards Chips";
            })
            .addCase(updateProcessorMotherBoardsMaxRam.fulfilled, (state, action) => {
                if (!action.payload?.id) return;
                state.processor_motherboards_max_ram_list = state.processor_motherboards_max_ram_list.map((processor_motherboards_max_ram) =>
                    processor_motherboards_max_ram.id === action.payload.id ? action.payload : processor_motherboards_max_ram);
            })
            .addCase(updateStatusInProcessorMotherBoardsMaxRam.fulfilled, (state, action) => {
                if (!action.payload?.id) return;
                // state.categoryList = state.categoryList.map((category) =>
                //   category.id === action.payload.id ? action.payload : category
                // );
            })
            .addCase(updateStatusInProcessorMotherBoardsMaxRam.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to update status";
            });
    },
});

export default categorySlice.reducer;
